import PropTypes from "prop-types";

import classnames from "classnames";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Label from "../../Label";

const Advanced = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  innerRef,
  required,
  direction,
  optional,
  ...rest
}) => {
  const toolbarOptions = [
    ["bold", "italic", "underline"],
    ["blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ color: [] }],
  ];
  const modules = { toolbar: toolbarOptions };
  return (
    <div
      className={classnames(
        "input__wrapper",
        { __error: touched && errors },
        direction,
      )}
    >
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
      />
      <div className={`input__wrapper--field`}>
        <ReactQuill
          ref={innerRef}
          className={classnames({
            "input--borderd--red": touched && errors,
            "disable--input": rest.disabled,
          })}
          theme="snow"
          placeholder={placeholder}
          modules={modules}
          {...rest}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

Advanced.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Advanced.defaultProps = {
  label: "",
  placeholder: "",
};
export default Advanced;
